import React from "react"
import { Field, Form } from "react-final-form"

import { useTranslations } from "@cirrus/core/i18n/provider"
import { TextButton } from "@cirrus/ui-kit-ts/src/components/atoms/Button/TextButton"
import { LabeledCheckbox } from "@cirrus/ui-kit-ts/src/components/atoms/LabeledCheckbox"

import { TwoFactorAuthenticationFormFieldNames } from "./types"
import { use2fa } from "./use2fa"
import { FormTitle } from "../../components/FormTitle"
import { GoBack } from "../../components/GoBack"
import { StyledLoginForm } from "../../components/StyledLoginForm"
import { SubmitButton } from "../../components/SubmitButton"
import { TextFieldLogon } from "../../components/TextFieldLogon"
import { FormHeader } from "../../containers/FormHeader"

const TWO_FA_INPUT_ID = "two-fa-input-id"

export const TwoFactorAuthenticationForm = () => {
  const { i18n } = useTranslations()
  const { handleLogin, submitting, error, cleanError } = use2fa()

  return <Form onSubmit={handleLogin}
               render={({ handleSubmit, values }) => <StyledLoginForm
                 onSubmit={handleSubmit}>
                   <FormHeader sx={{ marginBottom: "10px" }}>
                     <GoBack />
                     <FormTitle>{i18n("Account.Login:TFA_Title")}</FormTitle>
                   </FormHeader>

                   <Field name={TwoFactorAuthenticationFormFieldNames.two_fa_code}>
                     {({ input }) =>
                       <TextFieldLogon
                         {...input} width="auto"
                         id={TWO_FA_INPUT_ID} autoComplete="off"
                         inputProps={{
                           "aria-labelledby": TWO_FA_INPUT_ID
                         }}
                         label={i18n("Account.Login:TFA_CodePlaceholder")}
                         placeholder={i18n("Account.Login:TFA_CodePlaceholder")}
                         helperText={i18n(!!error ? "Account.Login:TFA_CodeErrorHelperText" : "Account.Login:TFA_CodeHelperText")}
                         error={!!error} disabled={submitting}
                         onChange={(event) => {
                           !!error && cleanError()
                           input.onChange(event)
                         }} />}
                   </Field>

                   <Field name={TwoFactorAuthenticationFormFieldNames.trust_browser} type="checkbox">
                     {({ input }) => (<LabeledCheckbox {...input}
                                                       label={i18n("Account.Login:TFA_TrustBrowser")}
                                                       disabled={submitting} />)}
                   </Field>

                   <SubmitButton label={i18n("General:Submit")} type="submit"
                                 isLoading={submitting}
                                 disabled={submitting} />
                   <TextButton id="helpButton" type="button" label={i18n("Account.Login:TFA_Help")}
                               onClick={() => window.open("https://help.cirrusassessment.com/api/docs/en/two-factor-authentication-2fa", "_blank")} />
               </StyledLoginForm>} />
}
